<template>
  <div class="h-100">
    <el-col class="h-100">
      <el-card shadow="never" style="height: calc(45% - 5px);">
        <div slot="header" class="clearfix">
          <span>电缆清单</span>
          <div style="float: right; padding: 3px 0;">
            <el-select
              class="select-model"
              v-model="selectionModel"
              style="width: 200px;"
              size="small"
              @change="changeCableModel"
            >
              <el-option
                v-for="item in cableModelList"
                :key="item.id"
                :label="item.name + `[${item.fileName}]`"
                :value="JSON.stringify(item)"
              ></el-option>
            </el-select>
            <el-tooltip placement="top" content="隐藏" :open-delay="1000">
              <span class="iconfont control-icon icon-left" @click="showCableMode"></span>
            </el-tooltip>
            <el-tooltip placement="top" content="关闭" :open-delay="1000">
              <span class="iconfont control-icon icon-close" @click="closeCableMode"></span>
            </el-tooltip>
          </div>
        </div>
        <div style="padding: 10px 16px;" class="h-100">
          <el-row :gutter="10">
            <el-col :span="6">
              <el-input
                v-model="searchData.cableCode"
                @keyup.native.enter="searchFilterData"
                size="small"
                placeholder="电缆编号"
                clearable
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-input
                size="small"
                clearable
                @keyup.native.enter="searchFilterData"
                v-model="searchData.cableList"
                placeholder="清册名称"
              ></el-input>
            </el-col>
            <el-col :span="6">
              <el-select
                filterable
                size="small"
                class="w-100"
                clearable
                @change="searchFilterData"
                v-model="searchData.lifeCycleStatus"
                placeholder="敷设状态"
              >
                <el-option
                  v-for="item in statusList"
                  :key="item.id"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-col>
            <el-col :span="6">
              <el-button size="small" type="primary" @click="searchFilterData">查询</el-button>
            </el-col>
          </el-row>
          <div class="m-t-10" style="height: calc(100% - 130px);">
            <el-table
              :data="tableData"
              border
              stripe
              @sort-change="sortChange"
              height="100%"
              highlight-current-row
              @row-click="clickRow"
              ref="cableTable"
            >
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="清册名称"
                prop="cableList"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="电缆编号"
                prop="cableCode"
              ></el-table-column>
              <el-table-column
                show-overflow-tooltip
                sortable="custom"
                label="敷设状态"
                prop="lifeCycleStatus"
              >
                <template slot-scope="scope">
                  {{
                    _.find(statusList, ['id', scope.row.lifeCycleStatus])
                      ? _.find(statusList, ['id', scope.row.lifeCycleStatus]).name
                      : ''
                  }}
                </template>
              </el-table-column>
            </el-table>
          </div>
          <div class="m-t-10">
            <el-pagination
              ref="cablePagination"
              background
              @current-change="changePageNo"
              :current-page.sync="pageNo"
              :page-size.sync="pageSize"
              layout="total, prev, pager, next"
              :total="pageTotal"
            ></el-pagination>
          </div>
        </div>
      </el-card>
      <el-card shadow="never" class="m-t-10 position-relative" style="height: calc(55% - 5px);">
        <div slot="header" class="clearfix">
          <span>电缆信息</span>
          <el-tooltip placement="top" content="会议记录" :open-delay="1000">
            <el-button
              style="float: right; padding: 5px 12px;"
              :disabled="!((moduleAuth && moduleAuth.read) || currentEnv.DEBUG)"
              icon="iconfont icon-bg-file"
              @click="showRecord"
            ></el-button>
          </el-tooltip>
        </div>
        <div class="h-90" style="padding: 10px 16px; overflow: auto;">
          <div class="cable-info">
            <div class="cable-info__list b-none d-flex flex-align-center">
              <p class="info-left">起点部件</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">
                {{ rowData ? rowData.startComponent : '' }}
              </p>
              <span
                class="p-0 p-r-10 iconfont icon-localtion"
                v-show="rowData && rowData.startComponent"
                @click="findComponentInPlayer(rowData.sCode || '', 'cable')"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">终点部件</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">
                {{ rowData ? rowData.endComponent : '' }}
              </p>
              <span
                class="p-r-10 iconfont icon-localtion"
                @click="findComponentInPlayer(rowData.eCode || '', 'cable')"
                v-show="rowData && rowData.endComponent"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">电缆编号</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">{{ rowData ? rowData.cableCode : '' }}</p>
              <span
                class="p-r-10 iconfont icon-localtion"
                v-show="rowData && rowData.cableCode"
                @click="findComponentInPlayer(rowData.cableCode || '', 'cable')"
              ></span>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">电缆规格</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">
                {{ rowData ? rowData.productType : '' }}
              </p>
            </div>
            <div class="cable-info__list d-flex flex-align-center b-none">
              <p class="info-left">参考长度</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">
                {{ rowData ? rowData.referenceQty : '' }}
              </p>
            </div>
            <div class="cable-info__list d-flex flex-align-center">
              <p class="info-left">三维长度</p>
              <p class="info-detail p-l-10 p-r-10 flex-1">{{ rowData ? rowData.desQty : '' }}</p>
            </div>
          </div>
          <div class="m-t-20" :style="{ height: `${cardHeight / 4 - 25}px` }">
            <el-tabs v-model="activeName">
              <el-tab-pane name="academic" label="设计院路径">
                <template v-if="rowData && rowData.referenceCableRoute">
                  <p
                    class="hover-route"
                    @click="centerToSelectRoute(item)"
                    v-for="(item, index) in rowData.referenceCableRoute.split(';')"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </template>
              </el-tab-pane>
              <el-tab-pane name="3d" label="三维敷设路径">
                <template v-if="rowData && rowData.desCableRoute">
                  <p
                    class="hover-route"
                    @click="centerToSelectRoute(item)"
                    v-for="(item, index) in rowData.desCableRoute.split(';')"
                    :key="index"
                  >
                    {{ item }}
                  </p>
                </template>
              </el-tab-pane>
            </el-tabs>
            <div class="bottom_btn" style="width: calc(100% - 16px);" v-if="isShowCheck">
              <el-button
                :disabled="
                  !rowData ||
                    (rowData &&
                      rowData.lifeCycleStatus !== 1 &&
                      rowData.lifeCycleStatus !== 2 &&
                      rowData.lifeCycleStatus !== 4) ||
                    !((moduleAuth && moduleAuth.update) || currentEnv.DEBUG)
                "
                size="small"
                style="width: 48%;"
                type="success"
                @click="openCheckDialog(1)"
                >检查通过</el-button
              >
              <el-button
                :disabled="
                  !rowData ||
                    (rowData &&
                      rowData.lifeCycleStatus !== 1 &&
                      rowData.lifeCycleStatus !== 2 &&
                      rowData.lifeCycleStatus !== 4) ||
                    !((moduleAuth && moduleAuth.update) || currentEnv.DEBUG)
                "
                type="danger"
                size="small"
                style="width: 48%;"
                @click="openCheckDialog(0)"
                >检查不通过</el-button
              >
            </div>
          </div>
        </div>
      </el-card>
    </el-col>
    <el-dialog
      :close-on-click-modal="false"
      title="会议记录"
      :visible.sync="recordDialog"
      @close="recordTable = []"
      width="700px"
    >
      <el-table :data="recordTable" border stripe height="400px">
        <el-table-column label="序号" width="90px">
          <template slot-scope="scope">{{ scope.$index + 1 }}</template>
        </el-table-column>
        <el-table-column label="会审结果" prop="result"></el-table-column>
        <el-table-column label="记录人" prop="createdUserName"></el-table-column>
        <el-table-column label="记录时间">
          <template slot-scope="scope">
            {{ moment(scope.row.createdTime).format('YYYY-MM-DD HH:mm:ss') }}
          </template>
        </el-table-column>
      </el-table>
    </el-dialog>
    <el-dialog
      :close-on-click-modal="false"
      title="会审"
      :visible.sync="checkDialog"
      @close="checkForm.result = ''"
      width="40%"
      class="check-dialog"
    >
      <el-form size="small" :model="checkForm" ref="checkForm" label-width="90px" class="p-r-20">
        <el-form-item label="会审结果：" prop="result">
          <el-input
            type="textarea"
            :rows="3"
            v-model.trim="checkForm.result"
            :maxlength="35"
          ></el-input>
        </el-form-item>
        <el-form-item label="记录人：" prop="result">
          <span>{{ userInfo.trueName }}</span>
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="checkDialog = false">取消</el-button>
        <el-button type="primary" @click="submitCheck" :loading="saveLoading">保存</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FnMixins from '@/assets/js/fnMixins'
import ApiMixinCable from '@/assets/js/api/cableManagement'
import ApiMixinDictionaryManagement from '@/assets/js/api/dictionaryManagement'
import ApiMixinDocument from '@/assets/js/api/documents'
import ConfirmAuth from '@/assets/js/confirmAuth'

import DocumentService from '@/services/DocumentService'

export default {
  mixins: [FnMixins, ApiMixinCable, ApiMixinDictionaryManagement, ApiMixinDocument],
  watch: {
    async $route(to) {
      if (this.$route.path.indexOf('/docView') > -1) {
        this.cableId = to.params.id
      }
    },
  },
  props: ['loadedModel', 'modelDocumentId'],
  async created() {
    this.moduleAuth = await ConfirmAuth('三维检查')
    this.isShowCheck = this.$route.query.showCheck ? this.$route.query.type === 'cabel' : false
    // 获取关键字
    const cableId = this.$route.query.cableId ? this.$route.query.cableId : ''
    if (this.$route.query.type === 'cabel' && cableId !== '') {
      this.pageSize = this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10
      this.listOrderBy = this.$route.query.orderBy ? this.$route.query.orderBy : ''
      this.orderIsAsc = this.$route.query.isAsc
      const params = {
        cableCode: { $txet: this.searchData.cableCode },
        cableList: { $txet: this.searchData.cableList },
        lifeCycleStatus: this.searchData.lifeCycleStatus,
        siteId: this.currentProject.id,
        pageSize: this.pageSize,
        status: 0,
        id: cableId,
      }
      if (this.listOrderBy) {
        params.sort = `${this.listOrderBy}:${this.orderIsAsc ? 'asc' : 'desc'}`
      }
      const res = await this.apiCable({
        method: 'findIndex',
        params,
      })
      if (res && res.code === 0 && res.data) {
        this.pageNo = res.data
      }
    }
    this.tableData = await this.initCableData()
    this.$nextTick(() => {
      this.$refs.cablePagination.internalCurrentPage = this.pageNo
    })

    this.statusList = this.getDiscipline()
    if (this.tableData.length > 0) {
      if (this.$route.query.type === 'cabel') {
        const index = _.findIndex(this.tableData, ['id', cableId])
        this.rowData = this.tableData[index]
        this.$refs.cableTable.setCurrentRow(this.tableData[index])
      }
    }
    await this.getCableModel()
    if (this.cableModelList.length) {
      if (this.modelDocumentId) {
        const cableModel = _.find(this.cableModelList, ['id', this.modelDocumentId])
        this.selectionModel = !_.isNil(cableModel)
          ? JSON.stringify(cableModel)
          : JSON.stringify(this.cableModelList[0])
      } else {
        this.selectionModel = JSON.stringify(this.cableModelList[0])
        this.changeCableModel(this.selectionModel)
      }
      if (this.rowData) {
        this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
        this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
      }
    }
    // 传值到模型
    this.$emit('setCableData', this.rowData)
    await this.routerInByCableList()
    // 定位到可视区域
    this.$nextTick(() => {
      const currentNode = document.getElementsByClassName('current-row')[0]
      if (currentNode) {
        this.$refs.cableTable.bodyWrapper.scrollTop = currentNode.offsetTop
      }
    })
  },
  activated() {
    // 定位到可视区域
    const currentNode = document.getElementsByClassName('current-row')[0]
    this.$refs.cableTable.bodyWrapper.scrollTop = currentNode.offsetTop
  },
  data() {
    return {
      isShowCheck: true,
      cableModelList: [],
      selectionModel: '',
      saveLoading: false,
      checkDialog: false,
      checkForm: {
        isPass: 0,
        result: '',
      },
      activeName: 'academic',
      recordDialog: false,
      recordTable: [],
      moduleAuth: null,
      cableId: 'noCableId',
      pageNo: 1,
      pageSize: this.$route.query.pageSize ? Number(this.$route.query.pageSize) : 10,
      pageTotal: 0,
      rowData: null,
      tableData: [],
      statusList: [],
      searchData: {
        cableCode: '',
        cableList: '',
        lifeCycleStatus: '',
      },
      timeOut: null,
      listOrderBy: 'cableList', // 列表排序字段
      orderIsAsc: true, // 列表排序方式
    }
  },
  computed: {
    cardHeight() {
      return `${window.innerHeight - 140}`
    },
    currentProject() {
      return this.$store.getters.currentProject || {}
    },
    userInfo() {
      return this.$store.getters.userInfo || {}
    },
  },
  methods: {
    // 排序
    async sortChange(column) {
      if (column.column === null) {
        return
      }
      this.listOrderBy = column.prop
      if (column.order === 'ascending') {
        this.orderIsAsc = true
        this.tableData = await this.initCableData()
      } else {
        this.orderIsAsc = false
        this.tableData = await this.initCableData()
      }
    },
    async getTagCode(id) {
      const res = await this.apiCable({
        method: 'tag',
        params: {
          id,
          code: '',
          pageSize: 100000,
          pageNo: 1,
          siteId: this.currentProject.id,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        return res.data[0].code
      }
      return null
    },
    // 点击定位
    findComponentInPlayer(tagCode, type) {
      this.$emit('moveCamera', tagCode)
    },
    // 关闭电缆模式
    closeCableMode() {
      this.$emit('closeCableMode', false)
    },
    // 隐藏或打开面板
    showCableMode() {
      this.$emit('isShowMode')
    },
    // 选择模型
    changeCableModel(val) {
      // 重新加载模型
      this.$emit('changePlayerId', JSON.parse(val))
    },
    // 获取模型列表
    async getCableModel() {
      this.cableModelList = []
      const res = await this.apiDocuments({
        method: 'baseDocumentModel',
        params: {
          pageNo: 1,
          pageSize: 1000000,
          parametercode: 'docClass3DModelClass',
          siteId: this.currentProject.id,
          sort: 'seqNo:asc',
          // code: data.cableCode,
        },
      })
      if (res && res.code === 0 && res.data && res.data.length) {
        this.cableModelList = res.data
      }
    },
    // 提交审查
    async submitCheck() {
      this.saveLoading = true
      const params = {}
      _.assign(params, this.checkForm)
      params.cableId = this.rowData.id
      params.createdTime = moment().format('YYYY-MM-DD HH:mm:ss')
      params.createdUser = this.userInfo.userId
      params.LastModifiedUser = this.userInfo.userId
      const result = await this.apiCable({ method: 'check', params })
      this.saveLoading = false
      if (result && result.code === 0) {
        const obj = {}
        _.assign(obj, this.rowData)
        obj.siteId = this.currentProject.id
        obj.lifeCycleStatus = this.checkForm.isPass === 0 ? 4 : 3
        const res = await this.apiCable({ method: 'edit', params: obj })
        if (res && res.code === 0 && res.data) {
          this.$message.success(res.msg)
          _.assign(this.rowData, res.data)
          this.checkDialog = false
          this.tableData = await this.initData()
          this.$refs.cableTable.setCurrentRow(_.find(this.tableData, { id: this.rowData.id }))
        }
      }
    },
    // 打开审批模态框
    openCheckDialog(isPass) {
      this.checkForm.isPass = isPass
      this.checkDialog = true
    },
    // 查看会议记录
    async showRecord() {
      if (this.rowData && this.rowData.id) {
        this.recordDialog = true
        const res = await this.apiCable({ method: 'record', params: { id: this.rowData.id } })
        if (res && res.code === 0 && res.data) {
          this.recordTable = res.data
        } else {
          this.recordTable = []
        }
      } else {
        this.$message.info('请先选择电缆')
        this.recordTable = []
      }
    },
    // 如果是从电缆清单点击过来
    async routerInByCableList() {
      if (this.cableId !== 'noCableId') {
        if ((this.moduleAuth && this.moduleAuth.read) || currentEnv.DEBUG) {
          this.rowData = this.tableData[0]
          this.$refs.cableTable.setCurrentRow(this.tableData[0])
          this.$nextTick(() => {
            if (this.$refs.cableTable) {
              this.$refs.cableTable.setCurrentRow(this.rowData)
            }
          })
          // await this.getCableModel(this.rowData)
          if (this.cableModelList.length) {
            this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
            this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
          }
          // 传值到模型
          this.$emit('setCableData', this.rowData)
        } else {
          this.rowData = null
          this.cableModelList = []
          // 传值到模型
          this.$emit('setCableData', this.rowData)
        }
      }
    },
    // 电缆列表
    async initCableData() {
      if ((this.moduleAuth && this.moduleAuth.read) || currentEnv.DEBUG) {
        this.listLoading = true
        const params = {
          cableCode: { $txet: this.searchData.cableCode },
          cableList: { $txet: this.searchData.cableList },
          lifeCycleStatus: this.searchData.lifeCycleStatus,
          siteId: this.currentProject.id,
          pageSize: this.pageSize,
          pageNo: this.pageNo,
          status: 0,
        }
        if (this.cableId !== 'noCableId' && !this.clickButton) {
          params.id = this.cableId
        }
        if (this.listOrderBy) {
          params.sort = `${this.listOrderBy}:${this.orderIsAsc ? 'asc' : 'desc'}`
        }
        const res = await this.apiCable({
          method: 'list',
          params,
        })
        this.listLoading = false
        if (res && res.code === 0 && res.data) {
          this.pageTotal = res.page && res.page.recordCount > 0 ? res.page.recordCount : 0
          return res.data
        }
        this.pageTotal = 0
        return []
      }
      return []
    },
    // 分页
    async changePageNo(page) {
      this.pageNo = page
      this.tableData = await this.initCableData()
      if (this.$refs.cableTable) {
        if (this.rowData) {
          const data = _.find(this.tableData, { id: this.rowData.id })
          if (data) {
            _.assign(this.rowData, data)
            this.$refs.cableTable.setCurrentRow(data)
            this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
            this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
            // await this.getCableModel(data)
          }
        }
      }
    },

    // 单击表格中的某一行数据
    async clickRow(row) {
      // 判断模型是否加载完全
      if (!this.loadedModel) {
        this.$message.warning('模型还未加载完全，请稍候再试~')
        this.setCurrent(this.rowData)
        return
      }
      if (this.timeOut) clearTimeout(this.timeOut)
      this.timeOut = setTimeout(async () => {
        this.rowData = row
        this.$refs.cableTable.setCurrentRow(row)
        if (this.cableModelList.length) {
          this.$set(this.rowData, 'sCode', await this.getTagCode(this.rowData.startEquipment))
          this.$set(this.rowData, 'eCode', await this.getTagCode(this.rowData.endEquipment))
        }
        // 传值到模型
        this.$emit('setCableData', this.rowData)
      }, 800)
    },
    setCurrent(row) {
      this.$refs.cableTable.setCurrentRow(row)
    },
    async searchFilterData() {
      this.rowData = null
      // 传值到模型
      this.$emit('setCableData', this.rowData)
      this.clickButton = true
      this.pageNo = 1
      this.tableData = await this.initCableData()
    },
  },
  beforeDestroy() {
    clearTimeout(this.timeOut)
    window.player.Native.ModelTree.restoreAllItemColor()
  },
}
</script>

<style lang="scss" scoped>

.select-model {
  margin-left: 50px;
}
.h-90 {
  height: 90%;
}
.control-icon {
  cursor: pointer;
  margin: 5px;
  font-size: 16px;
}
.cable-info {
  .cable-info__list {
    border: 1px solid #dcdfe6;
    font-size: 14px;
    .info-left {
      width: 30%;
      display: inline-block;
      padding: 8px 20px;
      background-color: #f2f2f2;
      border-right: 1px solid #dcdfe6;
    }
    span {
      cursor: pointer;
      color: #409eff;
    }
  }
  .b-none {
    border-bottom: none;
  }
}
/deep/ .el-card__body {
  padding: 0 !important;
  height: 100%;
  tr.current-row > td {
    background-color: #e8e882;
  }
  tr.el-table__row--striped.current-row td {
    background-color: #e8e882 !important;
  }
}
.bottom_btn {
  position: absolute;
  display: flex;
  justify-content: center;
  bottom: 2px;
}

</style>
